var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          staticClass: "mb-3 right",
          attrs: { variant: "primary" },
          on: {
            click: function ($event) {
              _vm.isModalOpen = true
            },
          },
        },
        [_vm._v("\n        Schadenposition hinzufügen\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "clear" }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "cost-unit-create-modal",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            size: "xl",
            title: "Schadenposition hinzufügen",
          },
          on: {
            hide: function ($event) {
              return _vm.reset()
            },
            show: _vm.loadForm,
          },
          model: {
            value: _vm.isModalOpen,
            callback: function ($$v) {
              _vm.isModalOpen = $$v
            },
            expression: "isModalOpen",
          },
        },
        [
          _c(
            "div",
            { staticClass: "record-cost-unit-create-modal" },
            [
              _c(
                "csp-desktop-info-card",
                {
                  attrs: {
                    cols: 12,
                    "form-context": _vm.formContext,
                    icon: "inticon-users",
                    title: "Kunde",
                  },
                  on: {
                    "cancel-form": _vm.reset,
                    save: _vm.saveCostUnitFormData,
                  },
                },
                [
                  _c("csp-record-detail-cost-unit-basedata", {
                    attrs: {
                      "form-context": _vm.formContext,
                      "hide-for-group-options": _vm.hideForGroupOptions,
                      "record-id": _vm.recordId,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }